import GenericBentoGridButtonComponent, {
  GenericBentoGridButtonProps,
} from 'composables/Product/GenericBentoGrid/components/GenericBentoGridButton';

export type GenericBentoGridSocialsProps = {
  id?: string;
  buttons: GenericBentoGridButtonProps[];
};

const GenericBentoGridSocialButtonsComponent = ({ buttons }: GenericBentoGridSocialsProps) => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-4 justify-self-center">
      {buttons.map((button) => (
        <div key={button.id}>
          <GenericBentoGridButtonComponent {...button} />
        </div>
      ))}
    </div>
  );
};

export default GenericBentoGridSocialButtonsComponent;
